import { ElForm } from "element-plus";
import { BaseController } from "./BaseController";
import { log } from "./utils/log";

export class BaseForm extends BaseController {
  /**
   * 构造搜索表单
   * @param el 挂载节点
   * @param component 组件
   * @param config 属性配置
   */
   constructor(
    el: Element,
    component: VueComponent,
    config: any
  ) {
    super(el, component, config)
  }

  /**
   * el表单组件实例
   * @memberof EditForm
   */
  get elFormInstance() {
    if(!this.controller) {
      return undefined
    }
    return this.controller.elFormInstance as  InstanceType<typeof ElForm>
  }

  /**
   * 设置表单数据
   * @param data 数据
   */
  setFormData(data: any) {
    if(this.controller && this.controller.setFormData) {
      this.controller.setFormData(data)
    } else {
      log('表单', '当前表单实例还未创建完成', 'error')
    }
  }

  /**
   * 重置表单
   */
  reset() {
    if(this.controller && this.controller.reset) {
      this.controller.reset()
    } else {
      log('表单', '当前表单实例还未创建完成', 'error')
    }
  }

  /**
   * 更新表单数据
   * @memberof BaseForm
   */
  updateFormData(data: any) {
    if(this.controller && this.controller.updateFormData) {
      this.controller.updateFormData(data)
    } else {
      log('表单', '当前表单实例还未创建完成', 'error')
    }
  }

  /**
   * 获取表单数据
   * @returns 表单数据
   */
  getFormData(): Promise<any> {
    if(this.controller && this.controller.getFormData) {
      return this.controller.getFormData()
    }
    log('表单', '当前表单实例还未创建完成', 'error')
    return Promise.reject('表单实例未找到')
  }

  /**
   * 直接获取表单数据，跳过规则校验
   * @returns 
   */
  getFormDataNotValidate() {
    if(this.controller && this.controller.getFormDataNotValidate) {
      return this.controller.getFormDataNotValidate()
    }
    log('表单', '当前表单实例还未创建完成', 'error')
    return {}
  }
  
  /**
   * 隐藏表单项
   */
  hideFormItemByKey(key: string | string[]) {
    if(this.controller && this.controller.hideFormItemByKey) {
      this.controller.hideFormItemByKey(key)
    } else {
      log('表单', '当前表单实例还未创建完成', 'error')
    }
  }

  /**
   * 显示表单项
   */
  showFormItemByKey(key: string | string[]) {
    if(this.controller && this.controller.showFormItemByKey) {
      this.controller.showFormItemByKey(key)
    } else {
      log('表单', '当前表单实例还未创建完成', 'error')
    }
  }
}